import { inBoundary, type PositionFix, type PropertyBoundary } from '@cht/shared'
import type { GeoFix } from '../platform/geolocation.js'

export interface AmbientPositionStore { put(fix: PositionFix): Promise<unknown> }

export class AmbientRecorder {
  constructor(
    private readonly store: AmbientPositionStore,
    private readonly boundary: PropertyBoundary,
    private readonly bufferMeters: number,
    private readonly propertyId: string,
    private readonly userId: string,
    private readonly makeId: () => string
  ) {}

  async accept(fix: GeoFix): Promise<boolean> {
    // Off-property fixes are dropped here, before they are ever queued.
    if (!inBoundary(fix, this.boundary, this.bufferMeters)) return false
    await this.store.put({ ...fix, id: this.makeId(), propertyId: this.propertyId, userId: this.userId })
    return true
  }
}
